import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'payoutList',
      path: '/subproperty/wallet/payout',
      component: () => import('@modules/stripe/stripe-payout/components/stripe-payout-list-table.vue'),
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
    },
  ],
}];
